import * as React from "react";
import {Button, Checkbox, ControlLabel, FormControl, FormGroup, HelpBlock, Modal} from "react-bootstrap";
import {FormattedMessage, InjectedIntl, InjectedIntlProps, injectIntl} from "react-intl";
import {LcdIcon} from "../../common/ui/icon/LcdIcon";
import {Role, User} from "../../user/model";
import {Api} from "../../api/InternalApi";

interface State {
  showModal: boolean;
  username: string;
  password: string;
  passwordConfirm: string;
  roles: Role[];
  rolesSelected: string[];
  enabled: boolean;
}

interface Props extends InjectedIntl, InjectedIntlProps {
  disabled: boolean;
  initialUsername?: string;
  initialEnabled?: boolean;
  initialRoles?: string[];
  onSuccess: (entry: User) => void;
  api: Api;
}

export class NewUserButtonPresentation extends React.Component<Props, State> {
  constructor(props) {
    super(props);
    this.state = {
      showModal: false,
      username: "",
      password: "",
      passwordConfirm: "",
      roles: [],
      rolesSelected: [],
      enabled: true,
    };
  }

  closeModal = () => {
    this.setState({
      ...this.state,
      showModal: false
    });
  }

  submitModal = (event: any) => {
    event.preventDefault();
    event.stopPropagation();
    if (typeof this.props.onSuccess === "function") {
      if (this.state.username.trim().length > 1 && this.state.password.length > 2 && this.state.password ===
          this.state.passwordConfirm) {
        this.props.onSuccess(
            {
              username: this.state.username.trim(),
              userAuthCredentials: this.state.password,
              roles: this.state.rolesSelected,
              enabled: this.state.enabled
            });
        this.closeModal();
      }
    }
  }

  openModal = () => {
    this.props.api.getAllRoles().then((roles: Role[]) => {
      this.setState({
        roles,
        username: this.props.initialUsername ? this.props.initialUsername : "",
        enabled: typeof this.props.initialEnabled !== "undefined" ? this.props.initialEnabled : true,
        password: "",
        passwordConfirm: "",
        rolesSelected: this.props.initialRoles ? this.props.initialRoles : [],
        showModal: true
      })
    })
  }

  private handleChange = (event: any) => {
    const {name, value} = event.target;
    const realValue = event.target.type === 'checkbox' ? event.target.checked : value;
    if (name === "rolesSelected" && event.target.selectedOptions) {
      const selectedOptions = event.target.selectedOptions;
      const values = [];
      for (let i = 0, l = selectedOptions.length; i < l; i++) {
        values.push(selectedOptions[i].value);
      }
      this.setState({
        ...this.state,
        rolesSelected: values
      });
    } else if (name === "username") {
      const noSpecialChars = value.replace(/[^\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF\w'-]+/g, '');
      event.target.value = noSpecialChars;
      this.setState({
        ...this.state,
        username: noSpecialChars
      });
    } else {
      // @ts-ignore
      this.setState({[name]: realValue});
    }
  }

  render() {

    // @ts-ignore
    const roleOptions = this.state.roles && this.state.roles.length > 0 ?
                        this.state.roles.map(r => {
                          return (<option value={r.role} key={r.role}>{r.role}</option>)
                        }) : []
    return (
        <>
          <Button className="user-tour-add-data-root-button" onClick={this.openModal}>
            <LcdIcon icon={"plus"}/>
            <FormattedMessage id="studio.users.users-button.add" defaultMessage="Add user"/>
          </Button>

          <Modal show={this.state.showModal} onHide={this.closeModal} bsSize="large" backdrop="static">
            <Modal.Header closeButton>
              <Modal.Title>
                <FormattedMessage id="studio.users.new-user.modal-header"
                                  defaultMessage="Enter new user information"
                />
              </Modal.Title>
            </Modal.Header>
            <form onSubmit={this.submitModal}>
              <Modal.Body>
                <FormGroup controlId="user-username-id">
                  <ControlLabel>
                    <FormattedMessage id="studio.users.new-user.label-username"
                                      defaultMessage="Username"
                    />
                  </ControlLabel>
                  <FormControl autoFocus type="text" name="username" value={this.state.username}
                               onChange={this.handleChange} required={true}/>
                </FormGroup>
                <FormGroup controlId="user-pass-id">
                  <ControlLabel>
                    <FormattedMessage id="studio.users.new-user.label-password"
                                      defaultMessage="Password"/>
                  </ControlLabel>
                  <FormControl type="password" name="password" value={this.state.password}
                               onChange={this.handleChange} required={true}/>
                  {
                      this.state.password && this.state.password.length < 4 &&
                      <HelpBlock>
                        <FormattedMessage
                            id="studio.users.new-user.help-password"
                            defaultMessage="Password length must be at least 4 characters"/>
                      </HelpBlock>
                  }
                </FormGroup>
                <FormGroup controlId="user-pass-confirm-id">
                  <ControlLabel>
                    <FormattedMessage id="studio.users.new-user.label-password-confirm"
                                      defaultMessage="Confirm password"
                    />
                  </ControlLabel>
                  <FormControl type="password" name="passwordConfirm" value={this.state.passwordConfirm}
                               onChange={this.handleChange} required={true}/>
                  {
                      this.state.passwordConfirm && this.state.passwordConfirm !== this.state.password &&
                      <HelpBlock>
                        <FormattedMessage
                            id="studio.users.new-user.help-password-confirm"
                            defaultMessage="Password must be equal to confirm password"/>
                      </HelpBlock>
                  }
                </FormGroup>
                <Checkbox name="enabled" checked={this.state.enabled} onChange={this.handleChange}>
                  <FormattedMessage id="studio.users.new-user.checkbox-user-enabled"
                                    defaultMessage="Enabled"
                  />
                </Checkbox>


                <FormGroup>
                  <ControlLabel htmlFor="user-select-roles-id">
                    <FormattedMessage id="studio.users.new-user.label-roles"
                                      defaultMessage="Select roles"
                    />
                  </ControlLabel>
                  <FormControl type="text" value={this.state.rolesSelected.join(", ")} readOnly={true}/>
                  <FormControl id="user-select-roles-id" componentClass="select" type="text"
                               name="rolesSelected" value={this.state.rolesSelected}
                               onChange={this.handleChange}
                               multiple={true} size={10} required={true}>
                    {roleOptions}
                  </FormControl>
                </FormGroup>
              </Modal.Body>
              <Modal.Footer>
                <Button type="submit">
                  <FormattedMessage
                      id="studio.users.new-user.button.ok"
                      defaultMessage="OK"
                  />
                </Button>
                <Button onClick={this.closeModal}>
                  <FormattedMessage
                      id="studio.users.new-user.button.close"
                      defaultMessage="Cancel"
                  />
                </Button>
              </Modal.Footer>
            </form>
          </Modal>
        </>
    );
  }
}

export const NewUserButton = injectIntl(NewUserButtonPresentation);